import CreatorPerformancePage from "./CreatorPerformancePage";

export default CreatorPerformancePage;
